import tokensInfo from '@/constants/tokensInfo'
import bignumber from '@/utils/bignumber'
import { getCorrectNetwork } from '@/environments'

export default {
  userDefaultWallet: state => state.wallets.length ? state.wallets[0] : 'unknown',
  tokensForTrade: state => {
    const isHasTokensAssetsProfile = (Object.keys(state.tokensAssetsProfile).length) && state.tokensAssetsProfile.tokens
    if (isHasTokensAssetsProfile) {
      const mapTokensAvaliable = state.tokensAvaliable.map((token) => {
        const tokenAssetsProfile = state.tokensAssetsProfile.tokens.find(t => t.code === token)
        const tokenWithBalance = state.tokensWithBalance[token] || { ...tokensInfo[getCorrectNetwork()][token], balance: bignumber(0) }
        const results = {
          ...tokenAssetsProfile,
          ...tokenWithBalance
        }
        return results
      })
      const expectedTokensForTrade = mapTokensAvaliable.filter(token => tokensInfo[getCorrectNetwork()].hasOwnProperty(token.code))
      return expectedTokensForTrade
    } else {
      return []
    }
  },
  sortTransactionHistory: state => {
    return state.transactionHistory.sort((first, sec) => sec.timestamp - first.timestamp)
  },
  sortUserNotification: state => {
    if (Object.keys(state.user).length && state.user.notifications && state.user.notifications.length) {
      return state.user.notifications.sort((first, sec) => sec.timestamp - first.timestamp)
    }
    return []
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js